<template>
  <div class="menu">
    <ul class="menu__items">
      <li
        v-if="policy && policy.new"
        class="menu-item"
      >
        <Dropdown
          :items="addOperationMenuItems(I18n)"
          placement="bottom-end"
        >
          <PlusIcon class="icon" />
        </Dropdown>
      </li>
      <li
        v-if="adminMenuItems && adminMenuItems.length > 0"
        class="menu-item"
      >
        <Dropdown
          :items="adminMenuItems"
          placement="bottom-end"
        >
          <GearIcon class="icon" />
        </Dropdown>
      </li>
      <li class="menu-item">
        <Dropdown
          :items="profileMenuItems(I18n)"
          placement="bottom-end"
          @click-item="onProfileMenuItem"
        >
          <div class="avatar">
            <p>{{ currentUser[0] }}</p>
          </div>
        </Dropdown>
      </li>
    </ul>
  </div>
</template>

<script setup>
import useAjax from '@/functions/use_ajax';
import I18n from 'i18n-js';

// Utils
import {
  profileMenuItems,
  addOperationMenuItems,
  logOut,
} from '@/functions/navigation';

// Components
import Dropdown from '@/components/generic/dropdown.vue';

// Icons
import GearIcon from '@/images/gear.svg';
import PlusIcon from '@/images/plus.svg';

defineProps({
  currentUser: { type: String, required: true, default: '' },
  adminMenuItems: { type: Array, required: true, default: null },
  policy: { type: Object, required: false, default: null },
});

const ajax = useAjax();

function onProfileMenuItem(item) {
  if (item.key === 'logout') {
    logOut(ajax);
  }
}
</script>
